import { StatesResponse } from '@/infrastructure/network/dto/StateDto';

export const statesDtoToStates = (statesDto: StatesResponse): StatesResponse => {
	return {
		results: statesDto.results.map((state) => ({
			id: state.id,
			abbreviation: state.abbreviation,
			title: state.title,
			countryId: state.countryId,
			isEnabled: state.isEnabled
		}))
	};
};
